<template>
  <div class="clearfix" :class="classObject">&nbsp;</div>
</template>

<script>
  export default {
    props: {
      wide: Boolean,
      biggest: Boolean,
      bootstrap: Boolean
    },

    computed: {
      classObject () {
        return {
          'clearfix-wide': this.wide,
          'clearfix-biggest': this.biggest,
          'col-sm-12': this.bootstrap
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Clearfix.vue?7c856296